import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import StabilityAiServices from '../../../services/stabilityAi.service';
import { formatElapsed, translateErrorMessage } from '../../../utils';
import { toast } from 'react-toastify';

const initialState = {
  nfts: [],
  status: 'idle',
};

const imageCreateAction = async ({ dispatch, getState }, body, createFn) => {
  if (!getState().auth.user?._id)
    return toast.error('You should authorize to the backend server to continue!');

  dispatch(slice.actions.handleStatus('pending'));
  try {
    const response = await createFn(body);
    dispatch(slice.actions.handleStatus('success'));
    const data = response?.data;
    return data;
  } catch (error) {
    if (error?.response?.status === 429) {
      dispatch(slice.actions.handleStatus('idle'));

      const delta = Number(error?.response?.data?.message);
      toast.error(`Too many attempts. Please try again in ${formatElapsed(delta)}.`);
    } else {
      dispatch(slice.actions.handleStatus('error'));
      toast.error(translateErrorMessage(error));
    }
    return error?.response?.data;
  }
};

export const txt2imgAction = createAsyncThunk('StabilityAi/txt2img', async (body, param) => {
  return await imageCreateAction(param, body, StabilityAiServices.txt2img);
});

export const slice = createSlice({
  name: 'stabilityAi',
  initialState,
  reducers: {
    handleStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(txt2imgAction.fulfilled, (state, action) => {
      if (state.status !== 'success') return;
      const { data } = action?.payload;
      state.nfts = data?.images || data || [];
    });
  },
});

export default slice.reducer;
